<section class="selector-panel" [class.is-success]="tone === 'success'">
  <p class="selector-panel__label">{{ label }}</p>
  <div class="selector-panel__pill">{{ value }}</div>
</section>
